import { ModuleWithProviders, NgModule } from '@angular/core';
import { NavigationWatcherService, NavigationWatcherServiceInitializer } from './navigation-watcher.service';
import { RouterExtensionsOptions } from './router-extensions-options';
import { RouterExtensionsOptionsToken } from './router-extensions-options-token';
import { RouterExtensionsRootModule } from './router-extensions-root.module';
import { RouterLinkWithHrefDirective } from './router-link-with-href.directive';
import { RouterLinkDirective } from './router-link.directive';

@NgModule({
  declarations: [RouterLinkDirective, RouterLinkWithHrefDirective],
  exports: [RouterLinkDirective, RouterLinkWithHrefDirective]
})
export class RouterExtensionsModule {
  static forRoot(options?: Partial<RouterExtensionsOptions>): ModuleWithProviders<RouterExtensionsRootModule> {
    const defaultOptions: RouterExtensionsOptions = {
      qualifyReplaceUrl: false
    };

    return {
      ngModule: RouterExtensionsRootModule,
      providers: [
        { provide: RouterExtensionsOptionsToken, useValue: { ...defaultOptions, ...options } },
        NavigationWatcherService,
        NavigationWatcherServiceInitializer
      ]
    };
  }
}
